<!-- Form row -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded && !casoCerrado && !disableOptions">
          <div class="row align-items-end">

            <div class="col-md-6 mb-3">
              <label for="selectUsuario" class="form-label" i18n>Administradores (*)</label>
              <select2 [data]="usuarios" id="selectUsuario" name="id_usuario" #id_usuario="ngModel"
                [(ngModel)]="model.id_usuario" multiple="false" displaySearchStatus="always" noLabelTemplate="true"
                [disabled]="casoCerrado"
                [ngClass]="{ 'is-invalid': (id_usuario.invalid && f.submitted) || (id_usuario.invalid && (id_usuario.dirty || id_usuario.touched))}">
              </select2>
            </div>

            <div class="col-md-3 mb-3">
              <label for="selectTipo" class="form-label" i18n>Tipo (*)</label>
              <select class="form-select" id="selectTipo" name="tipo" #tipo="ngModel" [(ngModel)]="model.tipo" required
                [disabled]="casoCerrado"
                [ngClass]="{ 'is-invalid': (tipo.invalid && f.submitted) || (tipo.invalid && (tipo.dirty || tipo.touched))}">
                <option value="" disabled selected i18n>Seleccione</option>
                <option value="LETRADO" i18n>LETRADO</option>
                <option value="ADMINISTRADOR" i18n>ADMINISTRADOR</option>
                <option value="SECRETARIA_GENERAL" i18n>SECRETARIA GENERAL</option>
              </select>
            </div>

            <div class="col-md-1 text-end mb-3">
              <button type="submit" class="btn btn-primary waves-effect waves-light"
                [disabled]="f.invalid || !model.id_usuario || casoCerrado || disableOptions">
                <!-- Deshabilitado si el caso está cerrado -->
                <span i18n>Añadir</span>
              </button>
            </div>
          </div>
        </form>

        <div class="position-relative mt-3"> <!-- Ajustado para reducir el margen superior -->
          <div id="status" class="spinner-container" *ngIf="isLoading">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>

          <div class="row mt-4" *ngIf="institucionesLoaded && institucionesList.length > 0; else noInstituciones">
            <div class="col-md-4" *ngFor="let institucion of institucionesList">
              <div class="card institucion-card">
                <div class="card-body">
                  <div class="d-flex flex-row">
                    <img *ngIf="avatarUrls[institucion.id_usuario!]" [src]="avatarUrls[institucion.id_usuario!]"
                         class="rounded-circle" style="width: 65px; height: 65px; object-fit: cover;">
                    <div class="ms-3 flex-grow-1">
                      <h5>{{ institucion.nombre }} {{ institucion.apellidos }}</h5>
                      <p>{{ traducirInstitucionTipo(institucion.tipo) }}</p>
                    </div>
                    <button type="button" class="btn btn-link position-absolute top-0 end-0"
                            (click)="!casoCerrado && openDeleteModal(institucion)"
                            [disabled]="casoCerrado || disableOptions">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <div class="form-check form-switch d-flex align-items-center w-100 mt-3">
                    <input type="checkbox" [id]="'switch_' + institucion.id" class="form-check-input me-2"
                           name="enviar_email_subida_archivo" [checked]="institucion.enviar_email_subida_archivo"
                           (change)="onSwitchChange(institucion.id)" [disabled]="casoCerrado || disableOptions">
                    <label for="'switch_' + institucion.id" class="form-check-label mt-0" i18n>Aviso de nuevos documentos</label>
                  </div>
                  <div class="form-check form-switch d-flex align-items-center w-100 mt-3">
                    <input type="checkbox" [id]="'switchHito_' + institucion.id" class="form-check-input me-2"
                           name="enviar_email_hito" [checked]="institucion.enviar_email_hito"
                           (change)="onSwitchChangeHitos(institucion.id)" [disabled]="casoCerrado || disableOptions">
                    <label for="'switch_' + institucion.id" class="form-check-label mt-0" i18n>Aviso de próximos vencimientos</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-template #noInstituciones>
            <p *ngIf="institucionesLoaded" i18n>No se ha encontrado ninguna Institución</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal para confirmar borrado -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar a</span> "{{ institucionToDelete?.nombre }} {{ institucionToDelete?.apellidos }}"?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>
